import { render, staticRenderFns } from "./HolidaysMain.vue?vue&type=template&id=f385b586"
import script from "./HolidaysMain.vue?vue&type=script&lang=js"
export * from "./HolidaysMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports